import { render, staticRenderFns } from "./GroupAdd.vue?vue&type=template&id=1990f592&"
import script from "./GroupAdd.vue?vue&type=script&lang=js&"
export * from "./GroupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports